import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";

const BackButton = ({ to, label = "Back", variant = "blue" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  // ✅ รองรับทั้ง Neon (blue) และ OPTX (indigo)
  const colorMap = {
    blue: {
      hoverBorder: "hover:border-blue-400",
      hoverText: "hover:text-blue-500",
      hoverIcon: "group-hover:text-blue-500",
    },
    indigo: {
      hoverBorder: "hover:border-indigo-400",
      hoverText: "hover:text-indigo-500",
      hoverIcon: "group-hover:text-indigo-500",
    },
  };

  const colors = colorMap[variant] || colorMap.blue;

  return (
    <button
      onClick={handleBack}
      className={`group flex items-center gap-1.5 sm:gap-2 rounded-md sm:rounded-lg
                 border border-gray-200 dark:border-gray-700 
                 bg-white/70 dark:bg-gray-800/60 backdrop-blur-md 
                 px-2.5 py-1.5 sm:px-3 sm:py-1.5
                 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-200
                 shadow-sm transition-all duration-200
                 ${colors.hoverBorder} ${colors.hoverText}
                 hover:shadow-md active:scale-[0.98]`}
    >
      <HiOutlineArrowNarrowLeft
        size={16}
        className={`text-gray-500 dark:text-gray-300 transition-all duration-200 sm:size-[18px] ${colors.hoverIcon}`}
      />
      <span className="group-hover:translate-x-[-1px] sm:group-hover:translate-x-[-2px] transition-all duration-200">
        {label}
      </span>
    </button>
  );
};

export default BackButton;
